//@ts-nocheck

'use client'

import React, { useContext } from 'react'
import Image from 'next/image'

import { SectionThemeContext } from '../../../contexts/SectionTheme.context'

import { Heading, Paragraph } from '../../atoms/Typography/Typography.component'
import { Col, Container, Row, SpacerBase } from '../../atoms/GridSystem'
import Button from '../../atoms/Button/Button.component'
import ItemsGrouped from '../../molecules/ItemsGrouped/ItemsGrouped.component'

import * as S from './TextImage.styles'

interface TextImageProps {
  sectionId: string
  title?: {
    as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
    typo: string
    content: string
  }
  subtitle?: {
    as: 'p' | 'span'
    typo: string
    content: string
  }
  body?: string
  ctaPrimary?: {
    label: string
    [key: string]: any
  }
  ctaSecondary?: {
    label: string
    [key: string]: any
  }
  image?: {
    src: string
    alt: string
  }
}

const TextImage = ({
  sectionId,
  title,
  subtitle,
  body,
  ctaPrimary,
  ctaSecondary,
  image,
  preTitle,
  withBackground,
  textAlign = 'left'
}: TextImageProps) => {
  const { selectedColorScheme } = useContext(SectionThemeContext)

  return (
    <S.TextImage colorScheme={selectedColorScheme} as="section" id={sectionId} withBackground={withBackground}>
      <Container>
        <Row $reverse={textAlign === 'right'}>
          <Col xs={12} lg={4} $direction="column" $offset={{lg: textAlign === 'right' ? 1 : 0}}>
            {preTitle ? (
              <>
                <Paragraph {...preTitle} />
                <SpacerBase xs={1} />
              </>
            ) : null}
            {title ? (
              <>
                <Heading as={title.as} typo={title.typo}>
                  {title.content}
                </Heading>
                <SpacerBase xs={1.5} />
              </>
            ) : null}
            {subtitle ? (
              <>
                <Paragraph {...subtitle} weight="regular" />
                <SpacerBase xs={1.5} />
              </>
            ) : null}
            {body ? (
              <>
                <SpacerBase xs={1.5} />
                <Paragraph typo="paragraphMD">
                  {body}
                </Paragraph>
              </>
            ) : null}
            {ctaPrimary || ctaSecondary ? (
              <>
                <SpacerBase xs={4} />
                <ItemsGrouped
                  direction={{ xs: "column", xl: "row" }} 
                  space={{ xs: 16, xl: 24 }} 
                  fullWidth={['xs', 'sm', 'md']}
                  justify={{ xs: "center", xl: "flex-start" }}
                >
                  {ctaPrimary && ctaPrimary?.label ? <Button {...ctaPrimary} variant="secondary" iconEnd="arrow-right" /> : null}
                  {ctaSecondary && ctaSecondary?.label ? <Button {...ctaSecondary} variant="secondary" iconEnd="arrow-right" /> : null}
                </ItemsGrouped>
                <SpacerBase xs={4} lg={0} />
              </>
            ) : null}
          </Col>
          <Col xs={12} lg={7} $offset={{lg: textAlign === 'right' ? 0 : 1}}>
            {image ? (
              <S.ImageWrapper>
                <Image src={image.src} alt={image.alt} fill sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw" />
              </S.ImageWrapper>
            ) : null}
          </Col>
        </Row>
      </Container>
    </S.TextImage>
  )
}

export default TextImage
